/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Availability of window-wide coverage, distinct from individual fragments.
 */
export enum OperationalHistoryWindowCoverage {

    FragmentPageOnly = 'fragment_page_only'
}
